export default {
    /**
     * Gets conversations, taking into account search query.
     *
     * @param state Vuex state
     *
     * @returns {T[]|conversations|[]|default.computed.conversations}
     */
    conversations: (state) => {
        if (state.searchQuery === '') {
            return state.conversations;
        }

        function checkMessage (message, searchTerm) {
            if (message.message.toLowerCase().includes(searchTerm)) {
                return true;
            }

            for (let j = 0; j < message.attachments.length; j++) {
                if (message.attachments[j].name_normalized.toLowerCase().includes(searchTerm)) {
                    return true;
                }
            }

            return false;
        }

        return state.conversations.filter((conversation) => {
            for (let i = 0; i < conversation.messages.length; i++) {
                if (checkMessage(conversation.messages[i], state.searchQuery)) {
                    return true;
                }

                for (let j = 0; j < conversation.messages[i].responses.length; j++) {
                    if (checkMessage(conversation.messages[i].responses[j], state.searchQuery)) {
                        return true;
                    }
                }
            }

            return false;
        });
    },

    /**
     * Get conversation by specified ID.
     *
     * @param state Vuex state
     *
     * @returns {Object}
     */
    conversation: (state) => conversationId => {
        return state.conversations.find((conversation) => conversation.id === conversationId);
    },

    /**
     * Calculates user unseen messages.
     *
     * @param state Vuex state
     *
     * @returns {Number}
     */
    unseenMessages: (state) => (conversationId, activeUserId, conversation) => {
        if (conversation === undefined) {
            conversation = state.conversations.find((conversation) => conversation.id === conversationId);
        }

        let unseen = 0;

        if (conversation === undefined || conversation.messages.length === 0) {
            return unseen;
        }

        function calculateUnseen (message, userId) {
            let pivot = message.recipients_pivot.filter(pivot => pivot.id === userId);

            return (pivot.length === 0) ? 0 : (pivot[0].seen_at === null ? 1 : 0);
        }

        for (let i = 0; i < conversation.messages.length; i++) {
            let message = conversation.messages[i];

            unseen += calculateUnseen(message, activeUserId);

            while (message.responses.length > 0) {
                message = message.responses[message.responses.length - 1];

                unseen += calculateUnseen(message, activeUserId);
            }
        }

        return unseen;
    },

    /**
     * Gets conversation by participating user.
     *
     * @param state Vuex state
     *
     * @returns {Object}
     */
    conversationByParticipants: (state) => userIds => {
        for (let i = 0; i < state.conversations.length; i++) {
            if (state.conversations[i].participants.filter((participant) => userIds.includes(participant.id)).length === userIds.length) {
                return state.conversations[i].id;
            }
        }

        return null;
    },
};
